import { useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { MekPortalView } from "../VIEW/MekPortalView";
import { useAuth } from "../FIREBASE/useAuth";
import routeUrls from "../COMPONENTS/navbar/navLink";

// Signed-in only; progress is kept in the browser
function MekPortalPage() {
  const { topic } = useParams<{ topic?: string }>();
  const { user, loading } = useAuth();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // Back to the same topic after signing in
    if (!loading && !user) history.replace(`${routeUrls.LOGIN}?from=${location.pathname}`);
  }, [user, loading]);

  if (loading || !user) return null;
  return <MekPortalView topicId={topic} />;
}

export default MekPortalPage;
